import { render, staticRenderFns } from "./Rental.yaml?vue&type=template&id=6531d08d&component"
import script from "./Rental.yaml?vue&type=script&lang=ts&component"
export * from "./Rental.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports